import React from 'react';
import { useContext } from 'react';
import { useMemo } from 'react';
import { UserAnalysisContext } from 'apps/sigma2-ui/src/state/user-analysis-context';

/** This hook is meant to act as a bridge between the User Analysis engine and the rest of the application.
 * Anytime a part of the application makes an action that may change the state of the user analyses (e.g. invoking a new custom viz),
 * it should use this hook to send a signal to the User Analysis engine. It's important to note that it is not required
 * to use this hook to send signals, but it is recommended to do so to ensure that the User Analysis engine
 * updates as soon as possible.
 * @param options - An object containing optional parameters.
 * @param options.onReceivedSignal - A callback function that will be called whenever a signal is received by the User Analysis engine. It is important to note that any time this gets invoked, a memo-ized version of the function will be created, so it is recommended to use useCallback to avoid unnecessary re-renders.
 */
export const useUserAnalysisSignaling = () => {
  const context = useContext(UserAnalysisContext);

  return useMemo(() => {
    return {
      sendSignal: context.sendSignal,
      currentUserAnalyses: context.currentUserAnalyses,
      onDeleteUserAnalysis: context.onDeleteUserAnalysis,
      onRetryUserAnalysis: context.onRetryUserAnalysis,
    };
  }, [context]);
};
